export enum TipoEmpresa{
    PARCEIRA ="P",
	CONVENIO = "V",
	CONTRATO = "T",
	FORNECEDOR = "F",
	CLIENTE = "C",
	OUTRO= "O",
	PARCEIRACLIENTE='L',
	PARCEIRAFORNECEDOR='R',
	PARCEIRACLIENTEFORNECEDOR='E',
	FORNECEDORCLIENTE='N'
	
}